module.exports = __webpack_public_path__ + "img/top-10-add-to-cart.36f10a79.jpg";